"use client";

import { Sparkles } from "lucide-react";
import type { Persona } from "../context/AnalyzeFileContext";
import { ALL_ADVISORS_EMPTY_DESCRIPTION, getAdvisorEmptyDescription } from "../advisorContent";
import { ANALYZE_SELECTION_CLASSES } from "../analyzeConstants";
import { PersonaAvatar } from "./PersonaAvatar";

type AnalyzeEmptyFeedStateProps = {
  focusedPersona: Persona | null;
  isGenerating: boolean;
  hasFilter: boolean;
};

export const AnalyzeEmptyFeedState = ({
  focusedPersona,
  isGenerating,
  hasFilter,
}: AnalyzeEmptyFeedStateProps) => (
  <div
    className={`flex flex-col items-center justify-center text-center px-6 py-12 ${ANALYZE_SELECTION_CLASSES}`}
  >
    {hasFilter && focusedPersona ? (
      <div className="mb-4">
        <PersonaAvatar persona={focusedPersona} size="lg" presentation="chip" />
      </div>
    ) : (
      <Sparkles className="h-10 w-10 text-muted-foreground/50 mb-4" strokeWidth={1.5} />
    )}

    {isGenerating && focusedPersona ? (
      <>
        <p className="text-base font-semibold text-foreground">{focusedPersona.name}</p>
        <p className="text-sm text-foreground/80 mt-1 max-w-[340px] leading-snug">
          {focusedPersona.description}
        </p>
        <p className="text-sm text-foreground/75 mt-4 max-w-[340px] leading-relaxed">
          Analysis in progress — results will appear here shortly.
        </p>
      </>
    ) : hasFilter && focusedPersona ? (
      <>
        <p className="text-base font-semibold text-foreground">{focusedPersona.name}</p>
        <p className="text-sm text-primary font-medium mt-1 max-w-[360px] leading-snug">
          {focusedPersona.description}
        </p>
        <p className="text-sm text-foreground/80 mt-4 max-w-[360px] leading-relaxed">
          {getAdvisorEmptyDescription(focusedPersona.id)}
        </p>
      </>
    ) : (
      <>
        <p className="text-base font-semibold text-foreground">No insights yet</p>
        <p className="text-sm text-foreground/80 mt-3 max-w-[360px] leading-relaxed">
          {ALL_ADVISORS_EMPTY_DESCRIPTION}
        </p>
      </>
    )}
  </div>
);
